<script setup>
import { useLoading } from '@/composables/useLoading';
import { computed } from 'vue';

const { isLoading, loaderMessage } = useLoading();

const loaderClasses = computed(() => ({
    'app-loader': true,
    'app-loader--active': isLoading.value
}));
</script>

<template>
    <Teleport to="body">
        <div :class="loaderClasses" v-if="isLoading">
            <div class="loader-container">
                <div class="loader">
                    <div class="bottom-section">
                        <div class="bottom" />
                        <div class="bottom" />
                        <div class="bottom" />
                        <div class="bottom" />
                    </div>
                    <div class="top-section">
                        <div class="bottom" />
                        <div class="bottom" />
                        <div class="bottom" />
                        <div class="bottom" />
                    </div>
                    <div class="middle" />
                </div>
                <div v-if="loaderMessage" class="loader-message">{{ loaderMessage }}</div>
            </div>
        </div>
    </Teleport>
</template>

<style scoped>
.app-loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    opacity: 0;
    visibility: hidden;
    transition:
        opacity 0.3s,
        visibility 0.3s;
}

.app-loader--active {
    opacity: 1;
    visibility: visible;
}

.loader-message {
    color: white;
    margin-top: 20px;
    font-size: 16px;
    text-align: center;
}
</style>
